import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import fontawesome from "@fortawesome/fontawesome";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
import brands from "@fortawesome/fontawesome-free-brands";
import solid from "@fortawesome/fontawesome-free-solid";
import regular from "@fortawesome/fontawesome-free-regular";
import VueAwesomeSwiper from "vue-awesome-swiper";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "swiper/dist/css/swiper.css";
import moment from "moment";
import "moment/locale/ko";
import VueMomentJS from "vue-momentjs";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueAwesomeSwiper);
Vue.use(VueMomentJS, moment);

fontawesome.library.add(brands, solid, regular);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
